// Ember parity: app/helpers/network-name.js — special-cased display names, else capitalize the key.
const NETWORK_NAMES: Record<string, string> = {
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
  youtube: 'YouTube',
  tiktok_creator_marketplace: 'TikTok',
  tiktok_v2: 'TikTok',
};

function capitalizeFirst(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function lookupNetworkName(key: string): string {
  return NETWORK_NAMES[key] || capitalizeFirst(key);
}

/**
 * Resolve a gig's social network into a display name (e.g. "Instagram", "TikTok").
 *
 * The `/paid_gigs/:id` payload exposes the network only through the computed
 * `social_network` relationship (no flat `network` attribute), so the value that
 * reaches us varies by how jsonapi-react resolves it: the full resource (use its
 * display `name`), the linkage id alone (the network key — map it), or nothing.
 * Accept every shape and fall back to the campaign's `network` key.
 */
export default function networkDisplayName(
  socialNetwork: unknown,
  campaignNetwork?: string | null
): string | null {
  if (socialNetwork && typeof socialNetwork === 'object') {
    const {name, id} = socialNetwork as {name?: unknown; id?: unknown};
    if (typeof name === 'string' && name) {
      return name;
    }
    if (typeof id === 'string' && id) {
      return lookupNetworkName(id);
    }
  }
  if (typeof socialNetwork === 'string' && socialNetwork) {
    return lookupNetworkName(socialNetwork);
  }
  if (campaignNetwork) {
    return lookupNetworkName(campaignNetwork);
  }
  return null;
}
